import React, { useEffect, useState } from 'react';

const FORM_ID = '8NDR96EK';

export default function GiveCloudForm() {
    const [loaded, setLoaded] = useState(false);

    const loadModule = callback => {
        const existingScript = document.getElementById('giveCloudScript');

        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://o-miami-inc.givecloud.co/v1/widgets.js';
            script.id = 'giveCloudScript';
            document.body.appendChild(script);
            script.onload = () => {
                if (callback) callback();
            };
        }
        if (existingScript && callback) callback();
    };

    useEffect(() => {
        loadModule(() => {
            setLoaded(true);

            const button = document.getElementById('giveCloudBtn');
            if (button)
                button.addEventListener('click', () => {
                    // eslint-disable-next-line no-undef
                    GivecloudWidgetApi.openModalEmbed({ fundraisingFormId: FORM_ID });
                });
        });
    });

    return (
        <div className="flex justify-center">
            {loaded && (
                <>
                    <div
                        data-fundraising-form={FORM_ID}
                        data-inline
                        data-secured-by-givecloud="light"
                    />
                    <button type="button" id="giveCloudBtn" className="dynamic-button text-xl">
                        <span className="dynamic-button__content">Donate Now</span>
                        <span className="dynamic-button__background" />
                    </button>
                </>
            )}
        </div>
    );
}
